// @flow

import React from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";
import { Button, Row, Col, View, OrganizationHierarchyTree } from "@components";
import { formatDateTime } from "@transformers/date";
import "./draft-hierarchy.style.scss";

const noop = () => undefined;

type PropsFromState = $Exact<{
  tree: Object,
  className?: string,
  onCreate: () => void,
  onSubmit: () => void,
  onEdit: () => void,
  onDiscard: () => void,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...PropsFromLocalize,
}>;

export class DraftHierarchy extends React.Component<Props> {
  getCreatedBy = (data: Object) =>
    data.updatedBy ? `${data.updatedBy.firstName} ${data.updatedBy.lastName}` : "";

  render() {
    return (
      <View flex="1" gap={3} className={classNames("draft-hierarchy", this.props.className)}>
        <View>
          <View direction="row" justifyContent="space-between" alignItems="center">
            <View>
              <h5>{this.props.t("DRAFT_HIERARCHY")}</h5>
            </View>
            {!this.props.tree && (
              <View>
                <Button materialIcon="edit_square" onClick={this.props.onCreate}>
                  {this.props.t("DRAFT")}
                </Button>
              </View>
            )}
            {this.props.tree && (
              <View direction="row" justifyContent="space-between">
                <Button materialIcon="publish" className=" ml-3" onClick={this.props.onSubmit}>
                  {this.props.t("PUBLISH")}
                </Button>
                <Button materialIcon="edit" className=" ml-3" onClick={this.props.onEdit}>
                  {this.props.t("EDIT")}
                </Button>
                <Button color="secondary" className=" text-danger" onClick={this.props.onDiscard}>
                  {this.props.t("DISCARD")}
                </Button>
              </View>
            )}
          </View>
        </View>
        {this.props.tree && (
          <View direction="row" padding={3} justifyContent="flex-start" className="hierarchy-info">
            <View flex="1">
              <span className="text-color-charcoal">{this.props.t("LAST_UPDATED_ON")}</span>
              <p>{formatDateTime(this.props.tree.updatedAt)}</p>
            </View>

            <View flex="1">
              <span className="text-color-charcoal">{this.props.t("UPDATED_BY")}</span>
              <p>{this.getCreatedBy(this.props.tree)}</p>
            </View>
          </View>
        )}

        <View className={classNames("draft-hierarchy-container", { bordered: !this.props.tree })}>
          {!this.props.tree && (
            <View flex="1" gap={3} alignItems="center" justifyContent="center">
              <View alignItems="center">
                <h4 className="d-block text-pinkish-grey text-center">
                  {this.props.t("THERE_IS_CURRENTLY_NO_DRAFT_HIERARCHY")}
                </h4>
                <Button materialIcon="edit_square" onClick={this.props.onCreate}>
                  {this.props.t("DRAFT")}
                </Button>
              </View>
            </View>
          )}
          {this.props.tree && (
            <OrganizationHierarchyTree
              tree={this.props.tree.structure}
              disabled={true}
              expanded={[]}
              onDrop={noop}
              onAction={noop}
              searchable={true}
              searchPlaceholder={this.props.t("FIND_DEPARTMENT")}
              hideEmployee
            />
          )}
        </View>
      </View>
    );
  }
}

export default localize()(DraftHierarchy);
